
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-rotate-cw",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-rotate-cw"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23 4v6h-6"}}),_c('path',{attrs:{"d":"M20.49 15a9 9 0 11-2.12-9.36L23 10"}})])
          )
        }
      }
    